import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import Quasar from 'quasar/src/vue-plugin.js';;
import quasarUserOptions from "./plugins/quasarUserOptions";
import fontAwesomePro from "./plugins/fontAwesomePro";
import cpnPlugins from "./plugins/cpnPlugins";

const app = createApp(App);

app.use(Quasar, quasarUserOptions, cpnPlugins, fontAwesomePro)
  .use(store)
  .use(router)
  .mount("#app");
